export interface CookieConsentState {
	isConsentGiven: boolean | undefined;
	isAccepted: boolean;
	isEnabled: boolean;
	ConsentGroup: ConsentCookie | undefined;
}

export interface ConsentCookie {
	marketing: ConsentType;
	targeting: ConsentType;
	performance: ConsentType;
	functional: ConsentType;
	necessary?: ConsentType;
	socialMedia?: ConsentType;
}
export interface GDPRConsent {
	GDPRTargetingAccepted?: GTMConsentStatus;
	GDPRPerformanceAccepted?: GTMConsentStatus;
	GDPRFunctionalAccepted?: GTMConsentStatus;
	gdpr_performance_enabled: GTMConsentStatus;
	gdpr_targeting_enabled: GTMConsentStatus;
	gdpr_functional_enabled: GTMConsentStatus;
}

export interface UserConsent {
	consentCookie: ConsentCookie;
	gdprConsent: GDPRConsent;
}

export interface UpdateConsentPayload {
	consentProperties: UserConsent;
	shouldSendGTM: boolean;
}

export enum GTMConsentStatus {
	Declined = "0",
	Accepted = "1",
}

export enum ConsentType {
	Declined = 0,
	Accepted = 1,
}
